if (!customElements.get("m-product-tabs")) {
  class MProductTabs extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        loadMoreBtn: "[data-load-more-product]",
        productsContainer: "[data-products-container]",
        tabContent: [".m-tab-content"],
        tabHeader: [".m-tab-header"],
        categoriesSlider: ".m-product-tabs__categories-slider",
        categoryControls: ".m-product-tabs__category-controls",
        viewAllLinks: ["[data-view-all]"],
      };
      this.tabSliders = [];
      this.sliderEnabled = this.dataset.enableSlider === "true";
      this.mobileSliderDisable = this.dataset.mobileDisableSlider === "true";
      this.buttonType = this.dataset.buttonType;
      this.domNodes = queryDomNodes(this.selectors, this);
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = parseInt(this.dataset.items, 10) || 4;
      this.mobileItems = parseFloat(this.dataset.mobileItems) || 1.2;
      const tabColumnGap = parseInt(this.dataset.tabColumnGap, 10);
      const tabColumnGapMobile = parseInt(this.dataset.tabColumnGapMobile, 10);
      this.tabColumnGap = Number.isNaN(tabColumnGap) ? 32 : tabColumnGap;
      this.tabColumnGapMobile = Number.isNaN(tabColumnGapMobile) ? 14 : tabColumnGapMobile;
      this.handleResponsiveChange = this.handleResponsiveChange.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.init();
    }

    disconnectedCallback() {
      document.removeEventListener("matchMobile", this.handleResponsiveChange);
      document.removeEventListener("unmatchMobile", this.handleResponsiveChange);
      document.removeEventListener("shopify:block:select", this.handleBlockSelect);
    }

    init() {
      if (this.sliderEnabled) {
        for (let block of this.domNodes.tabContent) {
          this.initSliderByScreenSize(block);
        }
        document.addEventListener("matchMobile", this.handleResponsiveChange);
        document.addEventListener("unmatchMobile", this.handleResponsiveChange);
      }
      if (this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;

        for (let block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }
      this.initCategorySlider();
      this.initTabs();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", this.handleBlockSelect);
      }
    }

    handleResponsiveChange() {
      for (let block of this.domNodes.tabContent) {
        this.initSliderByScreenSize(block);
      }

    }

    handleBlockSelect(event) {
      const block = event.target.closest("[data-index]");
      if (!block || !this.contains(block)) return;
      const index = Number(block.dataset.index);
      this.tabs.setActiveTab(index);
      this.afterTabChange(index);
    }

    initTabs() {
      this.tabs = new MinimogTheme.Tabs(this, (target) => {
        this.afterTabChange(Number(target.dataset.index));
      });
      this.afterTabChange(0);
    }

    afterTabChange(index) {
      const currentTab = this.domNodes.tabContent[index];
      if (!currentTab) return;

      const slider = currentTab.querySelector(".swiper-container");
      slider && slider.swiper && slider.swiper.update();

      this.domNodes.tabHeader.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.setAttribute("aria-selected", isActive.toString());
        tab.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      if (this.categorySlider) this.categorySlider.slideTo(index);

      this.domNodes.viewAllLinks.forEach((link) => {
        const url = currentTab.dataset.url;
        link.hidden = !url;
        if (url) link.href = url;
      });
    }

    initCategorySlider() {
      const sliderContainer = this.domNodes.categoriesSlider;
      if (!sliderContainer) return;

      const controls = this.domNodes.categoryControls;
      const prevButton = controls && controls.querySelector(".swiper-button-prev");
      const nextButton = controls && controls.querySelector(".swiper-button-next");
      const pagination = controls && controls.querySelector(".swiper-pagination");

      this.categorySlider = new MinimogLibs.Swiper(sliderContainer, {
        slidesPerView: 3.2,
        spaceBetween: this.tabColumnGapMobile,
        watchOverflow: true,
        threshold: 2,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        navigation:
          prevButton && nextButton
            ? {
                prevEl: prevButton,
                nextEl: nextButton,
              }
            : false,
        breakpoints: {
          768: {
            slidesPerView: 5,
            spaceBetween: this.tabColumnGap,
          },
          1280: {
            slidesPerView: 7,
            spaceBetween: this.tabColumnGap,
          },
        },
        on: {
          init: (swiper) => this.toggleControls(controls, swiper),
          breakpoint: (swiper) => this.toggleControls(controls, swiper),
          resize: (swiper) => this.toggleControls(controls, swiper),
        },
      });
    }

    toggleControls(controls, swiper) {
      if (!controls) return;
      controls.classList.toggle("m-product-tabs__controls--hidden", swiper.isLocked);
    }

    toggleProductControls(sliderContainer, swiper) {
      sliderContainer
        .querySelectorAll(".m-product-tabs__product-nav-controls, .m-product-tabs__product-controls")
        .forEach((controls) => this.toggleControls(controls, swiper));
    }

    initSliderByScreenSize(sliderContainer) {
      const mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      const slider = sliderContainer.querySelector(".m-mixed-layout__wrapper");
      const controlsContainers = sliderContainer.querySelectorAll(
        ".m-product-tabs__product-nav-controls, .m-product-tabs__product-controls"
      );

      if (MinimogTheme.config.mqlMobile && mobileDisableSlider) {
        controlsContainers.forEach((controls) => controls.classList.add("m:hidden"));
        slider.classList.remove("swiper-container");
        if (slider.swiper) slider.swiper.destroy(false, true);
      } else {
        controlsContainers.forEach((controls) => controls.classList.remove("m:hidden"));
        setTimeout(() => {
          this.initSlider(sliderContainer);
        });
      }
    }

    initSlider(sliderContainer) {
      const swiper = sliderContainer && sliderContainer.querySelector(".m-mixed-layout__wrapper");
      const navigationControls =
        sliderContainer.querySelector(".m-product-tabs__product-nav-controls") ||
        sliderContainer.querySelector(".m-product-tabs__product-controls");
      const paginationControls = sliderContainer.querySelector(".m-product-tabs__product-controls");
      const prevButton = navigationControls && navigationControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = navigationControls && navigationControls.querySelector(".m-slider-controls__button-next");
      const pagination = paginationControls && paginationControls.querySelector(".swiper-pagination");
      if (!swiper) return;

      if (swiper.swiper && !swiper.swiper.destroyed) {
        swiper.swiper.update();
        this.toggleProductControls(sliderContainer, swiper.swiper);
        return;
      }

      swiper && swiper.classList.add("swiper-container");

      const slider = new MinimogLibs.Swiper(swiper, {
        slidesPerView: this.mobileItems,
        spaceBetween: 0,
        watchOverflow: true,
        loop: false,
        pagination: this.showPagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        navigation:
          this.showNavigation && prevButton && nextButton
            ? {
                prevEl: prevButton,
                nextEl: nextButton,
              }
            : false,
        breakpoints: {
          768: {
            slidesPerView: this.items >= 3 ? 3 : this.items,
          },
          992: {
            slidesPerView: this.items >= 4 ? 4 : this.items,
          },
          1280: {
            slidesPerView: this.items,
          },
        },
        threshold: 2,
        on: {
          init: (swiperInstance) => this.toggleProductControls(sliderContainer, swiperInstance),
          breakpoint: (swiperInstance) => this.toggleProductControls(sliderContainer, swiperInstance),
          resize: (swiperInstance) => this.toggleProductControls(sliderContainer, swiperInstance),
        },
      });
    }

    initLoadMore(wrapper) {
      if (wrapper.dataset.loadMoreInitialized === "true") return;
      wrapper.dataset.loadMoreInitialized = "true";
      addEventDelegate({
        context: wrapper,
        selector: this.selectors.loadMoreBtn,
        handler: (e) => {
          e.preventDefault();
          this.handleLoadMore(wrapper);
        },
      });
    }

    handleLoadMore(wrapper) {
      const loadBtn = wrapper.querySelector(this.selectors.loadMoreBtn);
      const productsContainer = wrapper.querySelector(this.selectors.productsContainer);

      let currentPage = wrapper.dataset.page;
      currentPage = parseInt(currentPage);
      const totalPages = wrapper.dataset.totalPages;
      this.toggleLoading(loadBtn, true);

      const url = wrapper.dataset.url;
      const dataUrl = `${url}?page=${currentPage + 1}&section_id=${this.id}`;
      fetchCache(dataUrl).then((html) => {
        currentPage++;
        wrapper.dataset.page = currentPage;
        this.toggleLoading(loadBtn, false);
        const dom = generateDomFromString(html);
        const tabId = wrapper.getAttribute("id");
        const products = dom.querySelector(`#${tabId} ${this.selectors.productsContainer}`);

        if (products) {
          Array.from(products.childNodes).forEach((product) => productsContainer.appendChild(product));
          const slider = wrapper.querySelector(".swiper-container");
          if (slider && slider.swiper) {
            slider.swiper.update();
            if (slider.swiper.pagination) {
              slider.swiper.pagination.render && slider.swiper.pagination.render();
              slider.swiper.pagination.update && slider.swiper.pagination.update();
            }
            this.toggleProductControls(wrapper, slider.swiper);
          }
        }

        if (currentPage >= parseInt(totalPages)) loadBtn && loadBtn.remove();
      });

      // Remove button focus
      loadBtn.blur();
    }

    toggleLoading(loadBtn, status) {
      if (!loadBtn) return;
      if (status) {
        loadBtn.classList.add("m-spinner-loading");
      } else {
        loadBtn.classList.remove("m-spinner-loading");
      }
    }
  }
  customElements.define("m-product-tabs", MProductTabs);
}
